






import { Add as AddIcon, Comment, ThumbUp } from '@mui/icons-material'; // MUI icons
import { Tab, Tabs } from "@mui/material";
import axios from "axios";
import { useEffect, useMemo, useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'; // Circular Progress Bar
import 'react-circular-progressbar/dist/styles.css'; // Import styles for the progress bar
import Skeleton from 'react-loading-skeleton'; // Import Skeleton
import 'react-loading-skeleton/dist/skeleton.css'; // Skeleton CSS
import { useLocation } from 'react-router-dom';
import AddToListModal1 from './Addtolistmodal1';
import { IoArrowBack } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
const SearchDetails1 = () => {
  // Retrieve the influencer data from the passed statessdddd
  const location = useLocation();
  const { influencerData } = location.state;
  const navigate = useNavigate();
  // State to handle loading effect (true during loading, false after 3 seconds)
  const [loading, setLoading] = useState(true);
    const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [videoUrls, setVideoUrls] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [reelData, setReelData] = useState([]);
  const [error, setError] = useState(null);
  const [postImages, setPostImages] = useState([]);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


 
  const imagePosts = useMemo(() => {
    return influencerData?.lastPosts?.filter((post) => post.image !== null) || [];
  }, [influencerData]);

  const nullImagePosts = useMemo(() => {
    return influencerData?.lastPosts?.filter((post) => post.image === null) || [];
  }, [influencerData]);






useEffect(() => {
  if (tabValue === 0 && postImages.length === 0) {
    const fetchPostImages = async () => {
      setLoading(true);
      try {
        const requestData = {
          postUrls: influencerData.lastPosts.map((post) => post.url),
        };
        const response = await axios.post('https://server-side-influencer.onrender.com/fetch-post-images', requestData);
        setPostImages(response.data.postImages || []);
      } catch (err) {
        console.error("Error fetching post images:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPostImages();
  }
}, [tabValue, influencerData.lastPosts, postImages.length]);


  useEffect(() => {
    if (reelData.length === 0 && nullImagePosts.length > 0) {
      const fetchReelsData = async () => {
        const requestData = {
          urls: nullImagePosts.map((post) => post.url),
        };
  
        setLoading(true);
        try {
          const response = await axios.post(
            "https://server-side-influencer.onrender.com/getInstagramData",
            requestData
          );
          const results = response.data.results || [];
          setReelData(results);
          setVideoUrls(results.map(r => r.video_url));
          setError(null);
        } catch (err) {
          console.error("Error fetching data:", err);
          setError("An error occurred while fetching the data.");
          setReelData([]);
        } finally {
          setLoading(false);
        }
      };
  
      fetchReelsData();
    }
  }, [nullImagePosts, reelData.length]);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false); // After 3 seconds, set loading to false
    }, 3000);

    // Clear timeout if the component unmounts before 3 seconds
    return () => clearTimeout(timer);
  }, []);

 


  const logReelsUrls = () => {
    // Function to log URLs of REELS posts
    influencerData.lastPosts.forEach(post => {
      if (post.type === 'REELS') {
        console.log("REELS Post URL  i  found  here: ", post.url);
      }
    });
  };

  const formatNumber = (num) => {
    if (num >= 1e6) {
      return (num / 1e6).toFixed(1) + 'M'; // Format in millions
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(1) + 'K'; // Format in thousands
    }
    return num; // Return the number if it's less than 1000
  };


    useEffect(() => {
      const handleResize = () => {
 
        setIsSmallScreen(window.innerWidth <= 780);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  useEffect(() => {
    // Call the logReelsUrls function when the component is mounted
    if (influencerData.lastPosts) {
      logReelsUrls();
    }
  }, [influencerData.lastPosts]);
  return (
    <div className="flex min-h-screen " >
      {/* Left Sidebar: Navbar */}
      <div className="w-25 h-full fixed text-white shadow-lg" style={{ zIndex: 10 }}>
        <Navbar />
      </div>


      {/* Main Content Areass sss*/}
      <div className="w-3/4 p-6 overflow-y-auto bg-white" style={{ marginLeft: '0px', zIndex: 5 ,  marginTop: isSmallScreen ? '80px' : '10px'}}>
      
      
<div className=" mb-10 bg-gray-100 text-black flex items-center justify-between p-4 fixed w-full top-0 left-0 z-50 shadow-md" style={{ marginLeft: isSmallScreen ? '0px' : '86px' }} >
        <div onClick={() => navigate(-1)} className="cursor-pointer flex items-center  ">
          <IoArrowBack size={24} />
          <span className="ml-2">Back</span>
        </div>
        {/* <div className="text-right font-semibold text-lg">search details </div> */}
      </div>

        {/* Influencer Profile */}
        <div className="max-w-4xl mx-auto mt-10">
          <div className="flex items-center mb-6">
            {loading ? (
              <Skeleton circle={true} height={96} width={96} />
            ) : (
              // <img
              //   src={influencerData.image || 'https://via.placeholder.com/150'}
              //   alt={influencerData.name}
              //   className="w-24 h-24 object-cover rounded-full mr-4"
              // />
              <img
  src={influencerData.image || 'https://via.placeholder.com/150'}
  alt={influencerData.name}
  className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 object-cover rounded-full mr-4"
/>

            )}
            <div>
              {loading ? (
                <>
                  <Skeleton width={200} height={30} />
                  <Skeleton width={300} height={20} />
                  <Skeleton width={250} height={20} />
                  <Skeleton width={250} height={20} />
                  <Skeleton width={150} height={20} />
                  <Skeleton width={150} height={20} />
                </>
              ) : (
                <>
                <div className="flex items-center gap-0 mb-4">
  <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold ">{influencerData.name}</h1>

  {showModal && (
        <AddToListModal1
          influencerData={influencerData}
          onClose={() => setShowModal(false)}
          onAdded={() => {
            // callback after addedssssss
            console.log("Influencer successfully added to plan!");
          }}
        />
      )}
  <button
                 type="button"
                 onClick={() => setShowModal(true)}  className="ml-3 text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 flex items-center whitespace-nowrap mr-10"
              
               >
                 <AddIcon />
              Add to list
               </button> 
</div>

                  {/* <h1 className="text-3xl font-semibold  mb-4">{influencerData.name}</h1> */}
                  <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-2">{influencerData.description}</p>
                  <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-2">Email : {influencerData.contactEmail|| 'NA'}</p>
                  <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-2">Fake followers: {influencerData.pctFakeFollowers|| 'NA'}</p>
                  <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-2">Total collaborations: {influencerData.totalCollaborationCount|| 'NA'}</p>
                  <p className="text-lg text-black  mb-2 text-3xl">{formatNumber(influencerData.usersCount) || 'NA'} Followers</p>
                  <a
                    href={influencerData.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 mt-2 inline-block"
                  >
                    Instagram Profile
                  </a>
                </>
              )}


            </div>
          </div>
         
          {/* Engagement Statistics */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">
              {loading ? <Skeleton width={200} height={30} /> : 'Engagement Statistics'}
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {loading ? (
                <>
                  <div className="text-center">
                    <Skeleton width={60} height={30} />
                    <Skeleton width={60} height={20} />
                  </div>
                  <div className="text-center">
                    <Skeleton width={60} height={30} />
                    <Skeleton width={60} height={20} />
                  </div>
                  <div className="text-center">
                    <Skeleton width={60} height={30} />
                    <Skeleton width={60} height={20} />
                  </div>
                  <div className="text-center">
                    <Skeleton width={60} height={30} />
                    <Skeleton width={60} height={20} />
                  </div>
                </>
              ) : (
                <>
                  <div className="text-center">
                    <p className="font-semibold text-xl">{formatNumber(influencerData.avgLikes)}</p>
                    <p className="text-sm text-gray-500">Avg Likes</p>
                  </div>
                  <div className="text-center">
                    <p className="font-semibold text-xl">{formatNumber(influencerData.avgComments)}</p>
                    <p className="text-sm text-gray-500">Avg Comments</p>
                  </div>
                  <div className="text-center">
                    <p className="font-semibold text-xl">{formatNumber(influencerData.avgInteractions)}</p>
                    <p className="text-sm text-gray-500">Avg Interactions</p>
                  </div>
                  <div className="text-center">
                    <p className="font-semibold text-xl">{formatNumber(influencerData.avgViews) || 'N/A'}</p>
                    <p className="text-sm text-gray-500">Avg Views</p>
                  </div>
                </>
              )}
            </div>
          </div>


   {/* Engagement Rate as a Linear Progress Bar */}
          <div className="mb-8">
            <h3 className="text-xl font-semibold mb-5">{loading ? <Skeleton width={200} height={30} /> : 'Engagement Rate'}</h3>
            {loading ? (
              <Skeleton width={100} height={30} />
            ) : (
              <>
                <div className="flex items-center justify-between mb-4">
                  {/* <p className="font-semibold text-lg">Engagement Rate</p> */}
                  <p className="text-lg">{influencerData.avgER || 'N/A'}%</p>
                </div>
             
              </>
            )}
          </div>

          {/* Brand Safety */}
          <div className="mt-8">
            <h3 className="text-xl font-semibold mb-5">
              {loading ? <Skeleton width={200} height={30} /> : 'Brand Safety'}
            </h3>
            <div className="grid grid-cols-2 gap-6">
              {loading ? (
                <>
                  <Skeleton width={200} height={20} />
                  <Skeleton width={200} height={20} />
                </>
              ) : (
                <>
                  <div>
                    <p   className="text-xl font-semibold mb-5" ><strong>Ad Content:</strong> {influencerData.brandSafety.ad}</p>
                    <p className="text-xl font-semibold mb-5"><strong>Offensive Content:</strong> {influencerData.brandSafety.toxic}</p>
                  </div>
                  <div>
                 
                    {/* Circular Progress Bar for Brand Safety Scoress */}
              <div className="w-[120px] h-[120px] sm:w-[200px] sm:h-[200px] md:w-[270px] md:h-[240px] mx-auto">
  <CircularProgressbar
    value={influencerData.brandSafety.totalScore}
    text={`${influencerData.brandSafety.totalScore}%`}
    styles={buildStyles({
      textSize: '16px',
      pathColor: '#4caf50',
      textColor: 'black',
      trailColor: '#d6d6d6',
    })}
  />


<p className="text-xl font-semibold mb-5 text-center"><strong>Total Brand Safety Score</strong></p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Mentions Section */}
          <div className="mb-8  mt-10">
            <h2 className="text-2xl font-semibold mb-10">
              {loading ? <Skeleton width={200} height={30} /> : 'Mentions'}
            </h2>
            {loading ? (
              <Skeleton count={3} height={50} />
            ) : (
              influencerData.lastFromMentions && (
                <div className=" flex flex-wrap gap-6 " style={{ zIndex: 5 }}>
                  {influencerData.lastFromMentions.map((mention, index) => (
                    <div key={index} className="flex items-center mb-4 max-w-xs">
                      <img
                        src={mention.image || 'https://via.placeholder.com/150'}
                        alt={mention.name}
                        className="w-24 h-24 rounded-full object-cover"
                      />
                      <div className="ml-4">
                        <a
                          href={mention.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 text-xl font-semibold"
                        >
                          {mention.name}
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              )
            )}
          </div>




{/* Additional Statsaaaaaaaass ggsssssssss*/}
<div className="mt-8 mb-5">
  <h3 className="text-xl font-semibold mb-4">
    {loading ? <Skeleton width={200} height={30} /> : 'Additional Stats'}
  </h3>
  <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
    {loading ? (
      <>
        <Skeleton width={60} height={30} />
        <Skeleton width={60} height={30} />
        <Skeleton width={60} height={30} />
        <Skeleton width={60} height={30} />
      </>
    ) : (
      <>
        <div className="text-center">
          <p className="font-semibold text-xl">{influencerData.toMentions180d || 'NA'}</p>
          <p className="text-sm text-gray-500">Mentions in 180 Days</p>
        </div>
        <div className="text-center">
          <p className="font-semibold text-xl">{influencerData.fromMentions180d || 'NA'}</p>
          <p className="text-sm text-gray-500">Mentions From Others</p>
        </div>
        <div className="text-center">
          <p className="font-semibold text-xl">{influencerData.toMentionsViews180d || 'NA'}</p>
          <p className="text-sm text-gray-500">Views from Mentions</p>
        </div>
        <div className="text-center">
          <p className="font-semibold text-xl">{influencerData.fromMentionsViews180d || 'NA'}</p>
          <p className="text-sm text-gray-500">Views to Mentions</p>
        </div>
      </>
    )}
  </div>
</div>




          {/* Last Posts */}
          <div className="mb-8 mt-8" style={{ zIndex: 0 }}>
           

           <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">

            
            </div>



{/* Last Posts */}
<div className="mb-8 mt-8" style={{ zIndex: 0 }}>
  <h2 className="text-2xl font-semibold mb-4">
   
  </h2>

  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
    {/* No posts to display */}
  </div>
</div>








          {/* Tab Navigation and Content */}
          <div className="mt-8">
            <Tabs value={tabValue} onChange={handleTabChange}>
              <Tab label="Post" />
              <Tab label="Reels" />
            </Tabs>
        
            {tabValue === 0 && (
        <div className="mb-8 mt-8" style={{ zIndex: 0 }}>
          <h2 className="text-2xl font-semibold mb-4">
            {loading ? <Skeleton width={200} height={30} /> : 'Last Posts'}
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
            {loading ? (
              <Skeleton count={6} height={200} />
            ) : (
              influencerData.lastPosts.map((post, index) => {
                // Directly access the image URL from the `postImages` array by index
                const postImage = postImages[index]?.imageUrl || 'https://via.placeholder.com/150';

                return (
                  <div key={index} className="w-full bg-white rounded-lg shadow-md overflow-hidden group relative">
                    <a href={post.url} target="_blank" rel="noopener noreferrer">
                      <div className="relative">
                        {/* Show the image URL or fallback */}
                        <img
                          src={postImage}
                          alt="Post"
                          className="w-full h-56 object-fit-cover rounded-t-lg"
                        />
                        <div className="absolute inset-0 flex justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <span className="text-xl font-semibold">{post.text}</span>
                        </div>
                      </div>
                    </a>
                    <div className="p-4">
                      <div className="flex items-center justify-between text-gray-400 mt-2">
                        <div className="flex items-center gap-2">
                          <ThumbUp className="cursor-pointer text-gray-400 hover:text-red-500 transition-colors duration-300" />
                          <span>{post.likes}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Comment className="cursor-pointer text-gray-400 hover:text-blue-500 transition-colors duration-300" />
                          <span>{post.comments}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}

{tabValue === 1 && (
  <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
    {loading ? (
      <Skeleton height={250} count={6} />
    ) : (
      reelData.length ? (
        reelData.map((reel, index) => (
          <div key={index} className="mb-6">
            <video
              width="100%"
              controls
              className="rounded-lg"
              style={{ maxHeight: '250px', objectFit: 'cover' }}
            >
              <source src={reel.videoUrl || videoUrls[index]} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="mt-2 text-sm text-gray-700">{reel.caption}</p>
          </div>
        ))
      ) : (
        <p className="text-gray-500">No video data available.</p>
      )
    )}
  </div>
)}

          </div>
     

              {/* Suggested Tags Section */}
          <div className="mb-8 mt-8">
            <h3 className="text-xl font-semibold mb-5">{loading ? <Skeleton width={200} height={30} /> : 'Suggested Tags'}</h3>
            <div className="flex flex-wrap gap-4">
              {loading ? (
                <Skeleton width={100} height={30} />
              ) : (
                influencerData.suggestedTags?.map((tag, index) => (
                  <span
                    key={index}
                    className="bg-gray-300 text-black px-4 py-2 rounded-full text-sm font-semibold"
                  >
                    #{tag}
                  </span>
                ))
              )}
            </div>
          </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchDetails1;


